
import Vue from 'vue'

const state = {
  loading: false,
  refCount: 0,
  inputData: {
    producent: null,
    model: null,
    indexModul: []
  },
  centrale: [],
  moduly: [],
  obudowy: [],
  powiazania: [],
  modulSelected: [],
  filters: [],
  producenci: [],

  selectedElements: []
}

const getters = {
  inputData: state => state.inputData,
  centrale: state => state.centrale,
  moduly: state => state.moduly,
  obudowy: state => state.obudowy,
  producenci: state => state.producenci,
  powiazania: state => state.powiazania,
  modulSelected: state => state.modulSelected,
  filters: state => state.filters,
  selectedElements: state => state.selectedElements,
  loading: state => state.loading
}

const actions = {
  load_centrale({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_centrale.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_MC_CENTRALE', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  send_centrale({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_options_centrale.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // commit('SET_MC_OBUDOWY', all)
          // this.dispatch('load_powiazania', [])
          // this.dispatch('products/load_powiazania_centrale', [] , {root:true})
          this.dispatch('products/load_centrale', [] , {root:true})
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_moduly({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_moduly.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_MC_MODULY', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  send_moduly({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_options_moduly.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          // commit('SET_MC_OBUDOWY', all)
          // this.dispatch('load_powiazania_moduly', [])
          this.dispatch('products/load_moduly', [] , {root:true})
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_powiazania_centrale({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_powiazania_centrale.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_POWIAZANIA', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_powiazania_moduly({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_powiazania_moduly.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_POWIAZANIA', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_filters({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_filters.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(res => {
          // console.log(res)
          commit('SET_FILTERS', res)
          resolve(res)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_obudowy({ commit }, payload) {
    commit('products/SET_LOADING', true, { root: true })
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_obudowy.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          this.dispatch('products/load_filters', all)
          commit('SET_MC_OBUDOWY', all)
          resolve(all)
          setTimeout(() => {
            commit('products/SET_LOADING', false, { root: true })
          }, "1000");
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_obudowy_short({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_obudowy_short.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          // this.dispatch('products/load_filters', all)
          commit('SET_MC_OBUDOWY', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  send_connection_centrale({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_options_powiazanie_centrale.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          // commit('SET_MC_OBUDOWY', all)
          this.dispatch('products/load_powiazania_centrale', [] , {root:true})
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  send_connection_moduly({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_options_powiazanie_moduly.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          // commit('SET_MC_OBUDOWY', all)
          this.dispatch('products/load_powiazania_moduly', [] , {root:true})
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  get_selected_elements({ commit }, payload) {
    // console.log('payload',payload)
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_selected_elements.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_SELECTED_ELEMENTS', all)
          // this.dispatch('load_powiazania', [])
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  load_producenci({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_producenci.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          commit('SET_MC_PRODUCENCI', all)
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  send_producenci({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('mc_options_producenci.php',
        {
          ...payload
        })
        .then(r => r.data)
        .then(all => {
          // console.log(all)
          // commit('SET_MC_OBUDOWY', all)
          // this.dispatch('load_powiazania_moduly', [])
          this.dispatch('products/load_producenci', [] , {root:true})
          resolve(all)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
}

const mutations = {
  SET_LOADING (state, loading) {
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },
  SET_MC_CENTRALE(state, payload) {
    state.centrale = payload
  },
  SET_MC_MODULY(state, payload) {
    state.moduly = payload
  },
  SET_MC_OBUDOWY(state, payload) {
    state.obudowy = payload
  },
  SET_MC_PRODUCENCI(state, payload) {
    state.producenci = payload
  },
  SET_POWIAZANIA(state, payload) {
    state.powiazania = payload
  },
  SET_VAR_STATE(state, payload) {
    // console.log(payload)
    if (payload[2]) {
      state[payload[1]][payload[2]] = payload[0]
    } else if (payload[1]) {
      state[payload[1]] = payload[0]
    }
  },
  SET_SELECTED_ELEMENTS(state, payload) {
    // console.log(payload)
    state.selectedElements = Object.assign({}, payload);
    // state.selectedElements['obudowa'] = state.obudowy[0]
  },
  SET_FILTERS(state, payload) {
    state.filters = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js